export const app = {
  connectToYourWhatsappNumber: 'Conectar a tu número de WhatsApp',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Conectar tu Bot de WhatsApp con tu número de WhatsApp',
  connect: 'Conectar',
};
